import { render, staticRenderFns } from "./Second.vue?vue&type=template&id=2524196a&scoped=true"
import script from "./Second.vue?vue&type=script&lang=js"
export * from "./Second.vue?vue&type=script&lang=js"
import style0 from "./Second.vue?vue&type=style&index=0&id=2524196a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2524196a",
  null
  
)

export default component.exports